import React from 'react';
import { CircularProgress, Collapse, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { SurveyReply } from 'src/modules/campaigns/types';
import { DividedRow } from './DividedRow.styles';

type SurveyRepliesListProps = {
  open: boolean;
  loading: boolean;
  loaded: boolean;
  error: string | null;
  replies: SurveyReply[];
};

const SurveyRepliesList: React.FC<SurveyRepliesListProps> = ({
  open,
  loading,
  loaded,
  error,
  replies,
}) => {
  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <Stack direction="column" spacing={1} mt={0.5} pl={1.25}>
        {loading && (
          <Stack direction="row" spacing={1} alignItems="center">
            <CircularProgress size={14} />
            <Typography variant="body2" color="text.secondary">
              Loading replies...
            </Typography>
          </Stack>
        )}
        {!loading && error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}
        {!loading && !error && loaded && replies.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No replies yet.
          </Typography>
        )}
        {!loading && !error && replies.length > 0 && (
          <Stack direction="column" spacing={1}>
            {replies.map(reply => {
              const contactName = [reply.contact.firstName, reply.contact.lastName]
                .filter(Boolean)
                .join(' ');
              const contactLabel = contactName
                ? `${contactName} (${reply.contact.phoneNumber})`
                : reply.contact.phoneNumber;
              return (
                <DividedRow key={reply.id}>
                  <Typography variant="subtitle2">{contactLabel}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {reply.text || 'No response text.'}
                  </Typography>
                  <Typography variant="caption" color="text.disabled">
                    {dayjs(reply.dateCreated).format('MMM D, YYYY h:mm A')}
                  </Typography>
                </DividedRow>
              );
            })}
          </Stack>
        )}
      </Stack>
    </Collapse>
  );
};

export default SurveyRepliesList;
